<template>
    <b-col xs="12" lg="12">
        <b-card>
          <b-card no-body>
          <b-tabs card pills vertical nav-wrapper-class="w-40" v-model="tabIndex[1]">
            <b-tab :active="(index == 0) ? true : false" v-for="(change, index) in changelog" v-bind:key="change.version">
              <template slot="title">
                {{ change.version }}
              </template>
              <h3> {{ change.description }} </h3>
              <ul>
                <li v-for="changes in change.changes" :key="changes" v-html="changes"></li>
              </ul>
            </b-tab>
          </b-tabs>
          </b-card>
        </b-card>
      </b-col>
</template>
<script>
import Changelog from '../../../changelog.json'

export default {
    name: "Documentation",
    data: function() {
        return {
            tabIndex: [0, 0]
        }
    },
    computed: {
        changelog() {
          return Changelog
        }
    },
    mounted() {
      //console.log(Changelog)
    }
}
</script>
